export const HourglassSVG = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            className="shrink-0"
        >
            <circle
                cx="24"
                cy="24"
                r="24"
                transform="matrix(-1 0 0 1 48 0)"
                fill="white"
            />
            <path
                d="M18.018 35.2079H30.495C31.2017 35.2079 31.7747 34.6309 31.7747 33.9191V30.4761C31.7747 30.201 31.6873 29.9331 31.5252 29.7116L27.8349 24.6675C27.512 24.2262 27.5016 23.6276 27.809 23.1752L31.2312 18.1377C31.3768 17.9234 31.4548 17.6697 31.4548 17.4099V13.9422C31.4548 13.2304 30.8818 12.6533 30.1751 12.6533H18.018C17.3112 12.6533 16.7383 13.2304 16.7383 13.9422V17.3851C16.7383 17.6602 16.8257 17.9281 16.9877 18.1496L20.6579 23.1661C20.9905 23.6207 20.9905 24.2405 20.6579 24.6952L16.9877 29.7116C16.8257 29.9331 16.7383 30.201 16.7383 30.4761V33.9191C16.7383 34.6309 17.3112 35.2079 18.018 35.2079Z"
                stroke="#08172B"
                strokeWidth="2.50607"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.2178 31.3418H27.2963"
                stroke="#FB5950"
                strokeWidth="2.50607"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
